import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex",
    "height": "100%"
  }
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "product-name-cell"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1,
  class: "account-name-edit-input-box"
};
const _hoisted_6 = ["placeholder", "value", "onChange"];
const _hoisted_7 = {
  class: "account-id-container"
};
const _hoisted_8 = {
  class: "account-id"
};
const _hoisted_9 = ["id"];
const _hoisted_10 = {
  class: "account_type_badge"
};
const _hoisted_11 = {
  class: "ads"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Ads", -1);
const _hoisted_13 = {
  key: 0,
  class: "ads-accounts-wrapper"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "Add connections", -1);
const _hoisted_16 = {
  class: "dsp"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "DSP", -1);
const _hoisted_18 = {
  key: 0,
  class: "ads-accounts-wrapper"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, "Add connections", -1);
const _hoisted_21 = {
  key: 0,
  class: "delete-account-cell"
};
const _hoisted_22 = {
  key: 1,
  class: "d-flex align-item-center justify-content-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_thead = _resolveComponent("b-thead");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_WrapWithCopy = _resolveComponent("WrapWithCopy");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_b_td = _resolveComponent("b-td");
  const _component_account_connection_status = _resolveComponent("account-connection-status");
  const _component_advertising_account_with_flag = _resolveComponent("advertising-account-with-flag");
  const _component_stroked_plus_icon = _resolveComponent("stroked-plus-icon");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_button = _resolveComponent("app-button");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  const _component_app_modal = _resolveComponent("app-modal");
  const _component_create_account_side_bar = _resolveComponent("create-account-side-bar");
  const _component_advertising_account_side_bar = _resolveComponent("advertising-account-side-bar");
  const _component_DSPAccountSideBar = _resolveComponent("DSPAccountSideBar");
  const _component_app_card_connections = _resolveComponent("app-card-connections");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_app_card_connections, {
    class: "no-left-right-margin",
    loading: $data.dataLoading,
    "min-height": 300,
    scrollable: true,
    hasBorder: false
  }, {
    default: _withCtx(() => [!$data.dataLoading && $options.accounts.length > 0 ? (_openBlock(), _createBlock(_component_b_table_simple, {
      key: 0,
      striped: "",
      responsive: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_b_thead, {
        class: "account-table-thead-background"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_tr, null, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            class: "account-table-thead-background-text account_name",
            onClick: _cache[0] || (_cache[0] = $event => $options.updateSortType('name'))
          }, {
            default: _withCtx(() => [_createTextVNode("Account Name")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "account-table-thead-background-text account_type",
            onClick: _cache[1] || (_cache[1] = $event => $options.updateSortType('type'))
          }, {
            default: _withCtx(() => [_createTextVNode("Type")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "account-table-thead-background-text account_status",
            onClick: _cache[2] || (_cache[2] = $event => $options.updateSortType('status'))
          }, {
            default: _withCtx(() => [_createTextVNode("Connection status")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "account-table-thead-background-text account_connections"
          }, {
            default: _withCtx(() => [_createTextVNode("Connections")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "account-table-thead-background-text account_delete",
            style: {
              "width": "40px",
              "padding": "0"
            }
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_b_tbody, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.accounts, account => {
          return _openBlock(), _createBlock(_component_b_tr, {
            key: account.account_id
          }, {
            default: _withCtx(() => [_createVNode(_component_b_td, {
              class: "accounts-table-data account_name"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [$data.accountNameEditId === account.account_id && $data.nameEditLoading ? (_openBlock(), _createBlock(_component_b_spinner, {
                key: 0,
                small: "",
                style: {
                  "align-self": "stretch",
                  "margin": "0 auto"
                }
              })) : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["account-name-container", {
                  edit: $data.accountNameEditId === account.account_id,
                  editable: account.account_provider === 'Amazon Vendor Central'
                }]),
                onClick: $event => $options.onAccountNameClick(account)
              }, [_createElementVNode("div", _hoisted_3, [$data.accountNameEditId !== account.account_id ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(account.account_name), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("input", {
                type: "text",
                placeholder: $options.splitAccountName(account.account_name).name,
                value: $options.splitAccountName(account.account_name).name,
                class: "account-name-edit-input",
                autofocus: "",
                onChange: $event => $options.onAccountNameChange($event, account),
                onBlur: _cache[3] || (_cache[3] = () => {
                  $data.accountNameEditId = '';
                })
              }, null, 40, _hoisted_6), _createTextVNode(" - " + _toDisplayString($options.splitAccountName(account.account_name).country) + " - " + _toDisplayString($options.splitAccountName(account.account_name).type), 1)])), _createElementVNode("div", _hoisted_7, [_createVNode(_component_WrapWithCopy, null, {
                default: _withCtx(() => [_createElementVNode("span", _hoisted_8, _toDisplayString(account.account_id), 1)]),
                _: 2
              }, 1024), _createElementVNode("div", {
                id: `${account.account_id}_region`,
                class: "region"
              }, _toDisplayString($options.processedRegion(account)), 9, _hoisted_9), _createVNode(_component_app_popover, {
                target: `${account.account_id}_region`,
                placement: "top"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(account.region), 1)]),
                _: 2
              }, 1032, ["target"])])])], 10, _hoisted_2))])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "accounts-table-data account_type"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_10, _toDisplayString(account.account_provider == "Amazon Seller Central" ? "Seller" : "Vendor"), 1)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "accounts-table-data account_status"
            }, {
              default: _withCtx(() => [_createVNode(_component_account_connection_status, {
                status: account.credential_status,
                onReauthenticateAccount: $event => $options.reauthenticateAccount(account)
              }, null, 8, ["status", "onReauthenticateAccount"])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "accounts-table-data account_connections"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_hoisted_12, _ctx.amazonAdvertisingProfilesForAccount(account).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amazonAdvertisingProfilesForAccount(account), profile => {
                return _openBlock(), _createBlock(_component_advertising_account_with_flag, {
                  profile: profile,
                  onReauthenticateAccount: $event => $options.reauthenticateAccount(profile),
                  key: profile.account_id,
                  id: profile.account_id
                }, null, 8, ["profile", "onReauthenticateAccount", "id"]);
              }), 128)), !_ctx.isOmnyWorkspace ? (_openBlock(), _createBlock(_component_b_button, {
                key: 0,
                variant: "link",
                onClick: $event => $options.onOpenAdsSideBar(account),
                class: "plus-button"
              }, {
                default: _withCtx(() => [_createVNode(_component_stroked_plus_icon, {
                  color: "#2172E1"
                })]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.amazonAdvertisingProfilesForAccount(account).length == 0 ? (_openBlock(), _createBlock(_component_b_row, {
                key: 1
              }, {
                default: _withCtx(() => [_createVNode(_component_b_col, {
                  cols: "6"
                }, {
                  default: _withCtx(() => [!_ctx.isOmnyWorkspace ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "connect-button",
                    onClick: $event => $options.onOpenAdsSideBar(account)
                  }, [_createVNode(_component_stroked_plus_icon, {
                    color: "#2172E1"
                  }), _hoisted_15], 8, _hoisted_14)) : _createCommentVNode("", true)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _ctx.amazonDSPAdvertiserProfilesForAccount(account).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amazonDSPAdvertiserProfilesForAccount(account), profile => {
                return _openBlock(), _createBlock(_component_advertising_account_with_flag, {
                  profile: profile,
                  onReauthenticateAccount: $event => $options.reauthenticateAccount(profile),
                  key: profile.account_id,
                  id: profile.account_id
                }, null, 8, ["profile", "onReauthenticateAccount", "id"]);
              }), 128)), !_ctx.isOmnyWorkspace ? (_openBlock(), _createBlock(_component_b_button, {
                key: 0,
                variant: "link",
                onClick: $event => $options.onOpenDSPSideBar(account),
                class: "plus-button"
              }, {
                default: _withCtx(() => [_createVNode(_component_stroked_plus_icon, {
                  color: "#2172E1"
                })]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.amazonDSPAdvertiserProfilesForAccount(account).length == 0 ? (_openBlock(), _createBlock(_component_b_row, {
                key: 1
              }, {
                default: _withCtx(() => [_createVNode(_component_b_col, {
                  cols: "6"
                }, {
                  default: _withCtx(() => [!_ctx.isOmnyWorkspace ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "connect-button",
                    onClick: $event => $options.onOpenDSPSideBar(account)
                  }, [_createVNode(_component_stroked_plus_icon, {
                    color: "#2172E1"
                  }), _hoisted_20], 8, _hoisted_19)) : _createCommentVNode("", true)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "accounts-table-data account_delete"
            }, {
              default: _withCtx(() => [!_ctx.isOmnyWorkspace ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_app_button, {
                loading: account.account_id == $data.removeId ? $data.removeLoading : null,
                variant: "link",
                onClick: $event => $options.onRemove(account),
                style: {
                  "padding": "0",
                  "min-width": "fit-content"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_app_icon, {
                  icon: "remove",
                  color: "#BFBFBF"
                })]),
                _: 2
              }, 1032, ["loading", "onClick"])])) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), !$data.dataLoading && $options.accounts.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, " No accounts ")) : _createCommentVNode("", true), _createVNode(_component_app_modal, {
      modelValue: $data.confirmRemoveModal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.confirmRemoveModal = $event),
      title: "Confirm Account Removing",
      "cancel-title": "No",
      "ok-title": "Yes",
      onOk: $options.onRemoveConfirm
    }, {
      default: _withCtx(() => [_createTextVNode(" Are you sure you want to remove this account ? ")]),
      _: 1
    }, 8, ["modelValue", "onOk"]), _createVNode(_component_app_modal, {
      modelValue: $data.confirmAccountNameEditModal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.confirmAccountNameEditModal = $event),
      title: "Confirm Account Name Edit",
      "cancel-title": "No",
      "ok-title": "Yes",
      onOk: $options.onConfirmAccountNameEdit
    }, {
      default: _withCtx(() => [_createTextVNode(" Are you sure you want to change this account name to " + _toDisplayString($data.updatedAccount.account_name) + "? ", 1)]),
      _: 1
    }, 8, ["modelValue", "onOk"]), $data.createAccountSideBar ? (_openBlock(), _createBlock(_component_create_account_side_bar, {
      key: 2,
      modelValue: $data.createAccountSideBar,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.createAccountSideBar = $event),
      provider: $props.provider,
      regions: $data.regions,
      countries: $data.countries,
      hasCountries: true
    }, null, 8, ["modelValue", "provider", "regions", "countries"])) : _createCommentVNode("", true), $data.advertisingAccountSideBar ? (_openBlock(), _createBlock(_component_advertising_account_side_bar, {
      key: 3,
      modelValue: $data.advertisingAccountSideBar,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.advertisingAccountSideBar = $event),
      account: $data.sideBarAccount,
      profiles: _ctx.amazonAdvertisingProfilesForAccount($data.sideBarAccount),
      account_type: $data.accountTypes[$data.sideBarAccount.account_provider],
      onRefresh: $options.refreshAdvertisingAccountSideBar
    }, null, 8, ["modelValue", "account", "profiles", "account_type", "onRefresh"])) : _createCommentVNode("", true), $data.dspAccountSideBar ? (_openBlock(), _createBlock(_component_DSPAccountSideBar, {
      key: 4,
      modelValue: $data.dspAccountSideBar,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.dspAccountSideBar = $event),
      account: $data.sideBarAccount,
      account_type: $data.sideBarAccount.account_type,
      profiles: _ctx.amazonDSPAgencyProfilesForAccount($data.sideBarAccount),
      onRefresh: $options.refreshDSPAccountSideBar
    }, null, 8, ["modelValue", "account", "account_type", "profiles", "onRefresh"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])]);
}